// Helpers for the "Per Sq.m" signage quoting option.
// Rule: no change to price/amount — only the displayed Qty (total sqm) and Unit (SQM).
// Sqm area is (Length_mm/1000) x (Breadth/Height_mm/1000) and applies to RECTANGULAR boards only.

export const isRectangular = (item) => (item?.shape || '') === 'Rectangular';

export const computeAreaSqm = (item) => {
  if (!isRectangular(item)) return 0;
  const L = Number(item?.length_mm) || 0;
  const H = Number(item?.height_mm) || 0;
  return Math.round((L / 1000) * (H / 1000) * 1000) / 1000;
};

export const isSqmMode = (item) => item?.pricing_mode === 'sqm' && isRectangular(item);

// Given a signage line's board count and net line amount, return the SQM display.
// Amount is authoritative and unchanged; per-sqm rate is derived so qty x rate ≈ amount.
export const sqmLineDisplay = (item, boards, amount) => {
  const areaSqm = Number(item?.area_sqm) || computeAreaSqm(item);
  const totalSqm = Math.round(areaSqm * (Number(boards) || 0) * 1000) / 1000;
  const ratePerSqm = totalSqm > 0 ? Math.round((Number(amount) || 0) / totalSqm) : 0;
  return { areaSqm, totalSqm, ratePerSqm };
};
